import { useEffect, useMemo } from "react";
// import RouteLink from "found/Link";
import clsx from "clsx";
import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import useTracking from "common/hooks/useTracking";

import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";
// import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Modal from "@material-ui/core/Modal";
import Link from "@material-ui/core/Link";
// import Link from "found/Link";
// import logo from "../common/images/Pageant-media.png";
import bgPrimary from "../common/images/plum_banner_bleed.png";
import cutoff from "../common/images/cutoff.png";
import breakingNews from "../common/images/breaking-news.png";
import risks from "../common/images/risks.png";
import idea from "../common/images/idea.png";
import competition from "../common/images/competition.png";
import CloseIcon from "@material-ui/icons/Close";
// import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import howardKapiloffAvatar from "../common/images/howard_kapiloff_head.jpg";
import howardKapiloffModalAvatar from "../common/images/howard_kapiloff_modal.jpg";
// import kathyAvatar from "../common/images/kathy.png";
// import kathyModalAvatar from "../common/images/kathyModal.png";
import samanthaMarcusAvatar from "../common/images/samantha_marcus_head.png";
import samanthaMarcusModalAvatar from "../common/images/samantha_marcus_modal.png";

import markMuellerAvatar from "../common/images/mark_mueller_head.jpg";
import markMuellerModalAvatar from "../common/images/mark_mueller_modal.jpg";

import mikeFrassinelliAvatar from "../common/images/mike_frassinelli_head.jpg";
import mikeFrassinelliModalAvatar from "../common/images/mike_frassinelli_modal.jpg";

import jamesPradoRobertsAvatar from "../common/images/james_prado_roberts_head.jpg";
import jamesPradoRobertsModalAvatar from "../common/images/james_prado_roberts_modal.jpg";

// import megDragoAvatar from "../common/images/meg_drago.png";
// import megDragoModalAvatar from "../common/images/meg_drago_modal.png";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Hidden from "@material-ui/core/Hidden";
import ContactUsBanner from "components/user/ContactUsBanner";
import SocialBanner from "components/user/SocialBanner";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "absolute",
      padding: "1.125rem 1.5rem",
      background: "#fff",
      border: "1px solid #c3cace",
      borderRadius: ".25rem",
      WebkitBoxShadow: "0 1px 1px 0 rgb(0 0 0 / 9%)",
      boxShadow: "0 1px 1px 0 rgb(0 0 0 / 9%)",
      width: "100%",
    },
    fullWidth: {
      marginLeft: "calc(50% - 50vw)",
      marginRight: "calc(50% - 50vw)",
    },
    collapseRoot: {
      width: "100%",
      marginTop: "2rem",
    },
    accordion: {
      marginBottom: "1rem",
    },
    headingAccordion: {
      width: "100%",
      textTransform: "uppercase",
      padding: "6px",
      color: "#696868",
      fontSize: ".9rem",
      letterSpacing: ".6px",
      background: "#fff",
      textAlign: "center",
    },
    hero: {
      backgroundPosition: "50% 50%",
      backgroundSize: "cover",
      overflow: "hidden",
      padding: "2.625rem 0",
      position: "relative",
      backgroundImage: `url(${bgPrimary})`,
      color: "#ffffff",
    },
    cutoff: {
      marginBottom: "1.5rem",
      width: "100%",
      "@media (min-width: 48.0625em)": {
        float: "left",
        margin: " 0 2% 0 0",
        width: "25%",
      },
      "@media (min-width: 30.0625em) ": {
        marginBottom: "1.875rem",
      },
    },
    icon: {
      marginRight: theme.spacing(2),
    },
    cmImg: {
      height: "auto",
      maxWidth: "100%",
      fontStyle: "italic",
      verticalAlign: "middle",
    },
    section: {
      paddingBottom: "1.875rem",
      paddingTop: "1.875rem",
      "@media (min-width: 30.0625em)": {
        paddingBottom: "2.625rem",
        paddingTop: "2.625rem",
      },
      "@media (min-width: 48.0625em)": {
        paddingBottom: "3.5rem",
        paddingTop: "3.5rem",
      },
    },
    sectionLede: {
      marginBottom: "2rem",
      maxWidth: "39.1875rem",
      color: "#000",
      paddingTop: "12px",
      marginLeft: "auto",
      marginRight: "auto",
      "@media (min-width: 30.0625em)": {
        marginBottom: "2.625rem",
      },
      "@media (min-width: 48.0625em)": {
        marginBottom: "3.5rem",
      },
    },
    bgSilverLight: {
      backgroundColor: "#f6f7f8",
    },
    overview: {
      borderTop: "1px solid #97a0a5",
    },
    newsStats: {
      color: "#c3cace",
      marginTop: "2rem",
      textAlign: "center",
      "@media (min-width: 30.0625em)": {
        marginTop: "2.625rem",
      },
      "@media (min-width: 48.0625em)": {
        marginTop: "3.5rem",
      },
    },
    newsStatsItemSpan: {
      //   fontWeight: "600",
      fontSize: "0.875rem",
      lineHeight: "1.4286",
      color: "#6e787d",
      display: "block",
    },
    newsStatsItem: {
      fontSize: "4.5rem",
      // fontWeight: "400",
      paddingLeft: "1rem",
      paddingRight: "1rem",
      fontFamily: "Source Sans Pro",
      "@media (min-width: 30.0625em)": {
        fontSize: "4.5rem",
        fontWeight: "300",
      },
      "@media (min-width: 48.0625em)": {
        display: "inline-block",
        verticalAlign: "top",
      },
    },
    appBar: {
      background: "transparent",
      boxShadow: "none",
      color: "#6e787d",
      fontSize: ".9rem",
      letterSpacing: ".6px",
      "@media (min-width: 768px)": {
        "& .MuiTabs-flexContainer": {
          justifyContent: "center",
        },
      },
    },
    tabItemLabel: {
      background: "#fff",
      border: "1.5px solid #c3cace",
      borderRadius: ".1rem",
      padding: "8px 25px",
      margin: "25px 0 30px 5px",
    },
    activeTab: {
      color: "#fff",
      backgroundColor: "#3c3251",
      opacity: "1",
    },
    breakingNews: {
      height: "3.75rem",
      verticalAlign: "top",
      backgroundSize: "cover",
      marginLeft: "auto",
      marginRight: "auto",
      display: "block",
      marginBottom: ".6875rem",
    },
    keyPersonWrap: {
      justifyContent: "center",
    },
    subscribeTextLink: {
      color: theme.palette.primary.main,
    },
    heroContent: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
      marginTop: theme.spacing(4),
    },
    cardGrid: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    hfaCard: {
      backgroundColor: "#f6f7f8",
      padding: ".975rem",
      border: "1px solid #a0228e",
      height: "100%",
    },
    hfaCardContent: {},
    hfaCardContentTitle: {
      color: theme.palette.primary.main,
    },
    teamImg: {
      background: "#3e464b no-repeat 50% 33%",
      backgroundSize: "cover",
      paddingTop: "140%",
    },
    modalImg: {
      backgroundSize: "contain",
      height: "200px",
      backgroundRepeat: "no-repeat",
    },
    closeModalBtn: {
      right: "5%",
      top: "5%",
      borderRadius: "50%",
      cursor: "pointer",
      height: "2rem",
      width: "2rem",
      position: "fixed",
      minWidth: "unset",
      "@media (max-width: 767px)": {
        right: "0",
      },
    },
    modalTeamName: {
      color: theme.palette.primary.main,
      textTransform: "none",
    },
    modalTeamPosition: {
      color: "#6e787d",
    },
    modalTeamDescription: {
      fontSize: "1em",
    },
    teamDetail: {
      marginTop: ".5625rem",
    },
    teamName: {
      color: theme.palette.primary.main,
      textTransform: "none",
    },
    teamPosition: {
      fontSize: ".75rem",
      lineHeight: "1.5",
      color: "#6e787d",
      textAlign: "left",
    },
    socialNav: {
      height: "3rem",
      marginTop: "10px",
      marginBototm: "10px",
    },
    socialNavItem: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      border: "2px solid #dde2e5",
      borderRadius: "50%",
      textDecoration: "none",
      width: "40px",
      height: "40px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginLeft: "5px",
      marginRight: "5px",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    hfaLink: {
      color: theme.palette.primary.main,
      display: "flex",
    },
    hfaLinkSpan: {
      marginLeft: "6px",
    },
    hfaCsCard: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "0px",
      border: "none",
      boxShadow: "none",
    },
    cardTeamContent: {
      flexGrow: 1,
      backgroundColor: "#f6f7f8",
      "&:hover": {
        cursor: "pointer",
        "& $teamName": {
          color: theme.palette.primary.light,
        },
      },
    },
    card: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    cardMedia: {
      paddingTop: "56.25%", // 16:9
    },
    cardContent: {
      flexGrow: 1,
    },
    cardContentTitle: {
      fontSize: "1rem",
      // fontWeight: "bold",
      color: "#a0228e",
    },
    footer: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(6),
    },
    heroContactLink: {
      color: theme.palette.primary.contrastText,
    },
    heroContactUsButton: {
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: "unset",
      padding: "2px 35px",
      fontSize: "1.3rem",
      "&:hover": {
        backgroundColor: theme.palette.primary.contrastText,
      },
    },
    heroMain: {
      "& > .MuiTypography-root": {
        marginBottom: "1.4rem",
      },
    },
  })
);

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function getModalStyle() {
  const top = 10;

  return {
    top: `${top}%`,
    margin: "auto",
    maxWidth: "39.375rem",
    height: "80%",
    overflow: "auto",
  };
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const keyPersons = [
  {
    name: "Mark Mueller",
    position: "Editor",
    avatar: markMuellerAvatar,
    avatarModal: markMuellerModalAvatar,
    description:
      "Mark took over as the Editor of Hedge Fund Alert in 2019. He helps shape stories, adds context to coverage and looks for trends that impact financial markets, money managers and investors. Prior to joining Hedge Fund Alert, Mark worked at the New Jersey State Commission of Investigation, a government watchdog agency that exposes corruption and the misuse of taxpayer dollars.  Before that, he was an investigative reporter and editor at The Star Ledger of New Jersey and a general assignment reporter at The Boston Herald. Mark shares a Pulitzer Prize for breaking news and received a George Polk Award for investigative reporting. He's the recipient of more than 40 additional awards from groups that include the Religion Newswriters Association, the New Jersey Press Association and the National Association of Black Journalists. Mark earned his B.A. at New York University.",
  },
  {
    name: "Howard Kapiloff",
    position: "Managing Editor",
    avatar: howardKapiloffAvatar,
    avatarModal: howardKapiloffModalAvatar,
    description:
      "Howard is the Managing Editor of Hedge Fund Alert, where he leads coverage of the hedge fund industry, including fund launches, closings, regulatory matters and news related to service providers. He guides his team on trends, features, and listings.\n" +
      "\n\n" +
      "Howard served as an Assistant Editor and Reporter at InvestmentNews prior to joining Hedge Fund Alert in 2000. Before that, he was a reporter at American Banker and at Financial Planning Magazine. Howard earned his M.S. in Journalism from Columbia University and his B.A. in English from the University of Denver.",
  },

  {
    name: "Samantha Marcus",
    position: "Senior Writer",
    avatar: samanthaMarcusAvatar,
    avatarModal: samanthaMarcusModalAvatar,
    description:
      "Samantha Marcus joined Hedge Fund Alert in August 2021 as a senior writer. She previously covered the $98.7 billion New Jersey Pension Fund and the state budget for The Star-Ledger. A native of the Chicago suburbs, she’s also reported on local government at The Morning Call in Allentown, Pennsylvania, the La Crosse Tribune in La Crosse, Wisconsin, and the Republican Eagle in Red Wing, Minnesota.",
  },
  {
    name: "Mike Frassinelli",
    position: "Senior Writer",
    avatar: mikeFrassinelliAvatar,
    avatarModal: mikeFrassinelliModalAvatar,
    description:
      "Mike is a Senior Writer on Hedge Fund Alert Report, covering law-enforcement and regulatory actions, hiring and compensation trends and institutional investors for the publication.\n\n" +
      "\n\n" +
      "Mike joined HFA in 2014 from The Star Ledger, where he wrote on transportation and general news for more than 10 years. Before that he was a staff writer for the Morning Call, a local Pennsylvania newspaper, for nine years and a staff writer for York Daily Record, another local PA paper, for seven years.  Mike has a BA in journalism from Penn State.",
  },
  {
    name: "James Prado Roberts",
    position: "Deputy Managing Editor",
    avatar: jamesPradoRobertsAvatar,
    avatarModal: jamesPradoRobertsModalAvatar,
    description:
      "James is a Deputy Managing Editor on Hedge Fund Alert Report where he produces exclusive news in the hedge fund and private debt fund sectors, including new launches, seeding, stake-taking, closures and unusual changes in assets and performance.\n\n" +
      "\n\n" +
      "Before joining HFA in 2011, James worked for its sister publication Private Equity Insider for three years. Prior to that James was an investigative reporter at Asbury Park Press, a local New Jersey newspaper, for 13 years and a reporter with the News Tribune, a local paper in Tacoma, for two years.",
  },
];

export default function Welcome() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [person, setPerson] = React.useState(0);
  const { handlePushEvent } = useTracking();

  const handleOpen = (personId: number) => {
    setOpen(true);
    setPerson(personId);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const bodyModal = (
    <div style={modalStyle} className={classes.paper}>
      <Box
        className={classes.modalImg}
        style={{ backgroundImage: `url(${keyPersons[person].avatarModal})` }}
      ></Box>
      <Box className={classes.teamDetail}>
        <Typography
          component="h2"
          variant="h2"
          align="left"
          gutterBottom
          className={classes.modalTeamName}
        >
          {keyPersons[person].name}
        </Typography>
        <Typography
          paragraph
          gutterBottom
          className={classes.modalTeamPosition}
        >
          {keyPersons[person].position}
        </Typography>
        <Typography
          paragraph
          gutterBottom
          className={classes.modalTeamDescription}
        >
          {keyPersons[person].description}
        </Typography>
      </Box>
    </div>
  );

  useEffect(() => {
    document.title = "Hedge Fund Alert";
  }, []);

  useEffect(() => {
    handlePushEvent("pageLoad", {
      page: "home",
    });
  }, []);

  return (
    <>
      <div className="news-alerts-landing-container">
        <Box className={clsx(classes.fullWidth, classes.hero, classes.section)}>
          <Container>
            <img
              className={clsx(classes.cmImg, classes.cutoff)}
              src={cutoff}
              alt={process.env.REACT_APP_SITE_NAME}
            />
            <Box className={classes.heroMain}>
              <Typography component="h2" variant="h2">
                Hedge Fund Alert
              </Typography>
              <Typography paragraph>
                Weekly update shedding light on the key operations of the US
                fund-management industry
              </Typography>
              <Typography paragraph>
                To find out how to subscribe click below or call{" "}
                <Link
                  className={classes.heroContactLink}
                  href="tel:+1 646 891 2126"
                >
                  +1 646 891 2126
                </Link>
              </Typography>

              <Button
                color="primary"
                variant="outlined"
                href="/subscribe-us"
                className={classes.heroContactUsButton}
              >
                Subscribe Now
              </Button>
            </Box>
          </Container>
        </Box>
        <Box
          className={clsx(
            classes.fullWidth,
            classes.overview,
            classes.bgSilverLight,
            classes.section
          )}
        >
          <Container>
            <Typography
              component="h3"
              variant="h3"
              align="center"
              color="textSecondary"
              gutterBottom
            >
              Publication Overview
            </Typography>
            <Typography
              paragraph
              align="center"
              gutterBottom
              className={classes.sectionLede}
            >
              Leverage fresh intel on discreet developments to anticipate
              industry risks and opportunities with Hedge Fund Alert. This
              weekly publication conveys the earliest look at key dealings and
              intelligence in the hedge fund arena.
            </Typography>

            <Box className={classes.newsStats}>
              <Box className={classes.newsStatsItem}>
                <span>20+</span>
                <span className={classes.newsStatsItemSpan}>
                  Years of Reporting
                </span>
              </Box>
              <Box className={classes.newsStatsItem}>
                <span>6K+</span>
                <span className={classes.newsStatsItemSpan}>Users</span>
              </Box>
            </Box>
            <Hidden smDown>
              <Box>
                <AppBar position="static" className={classes.appBar}>
                  <Tabs
                    value={value}
                    variant="scrollable"
                    scrollButtons="auto"
                    onChange={handleChange}
                    centered={true}
                    TabIndicatorProps={{ style: { display: "none" } }}
                  >
                    <Tab
                      className={
                        value === 0
                          ? clsx(classes.tabItemLabel, classes.activeTab)
                          : classes.tabItemLabel
                      }
                      label="Overview"
                      {...a11yProps(0)}
                    />
                    <Tab
                      className={
                        value === 1
                          ? clsx(classes.tabItemLabel, classes.activeTab)
                          : classes.tabItemLabel
                      }
                      label="Publication Coverage"
                      {...a11yProps(1)}
                    />
                    <Tab
                      className={
                        value === 2
                          ? clsx(classes.tabItemLabel, classes.activeTab)
                          : classes.tabItemLabel
                      }
                      label="About The Databases"
                      {...a11yProps(2)}
                    />
                  </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                  <Grid container spacing={4}>
                    <Grid item key={1} xs={12} sm={12} md={6}>
                      <Card className={classes.hfaCard}>
                        <CardContent className={classes.hfaCardContent}>
                          <img
                            className={clsx(
                              classes.cmImg,
                              classes.breakingNews
                            )}
                            src={breakingNews}
                            alt={process.env.REACT_APP_SITE_NAME}
                          />
                          <Typography
                            component="h3"
                            variant="h3"
                            align="center"
                            gutterBottom
                            className={classes.hfaCardContentTitle}
                          >
                            Receive Breaking News &amp; Exclusive Stories
                          </Typography>
                          <Typography paragraph gutterBottom>
                            <ul>
                              <li>
                                Obtain spotlights on key industry developments
                                that haven't been reported anywhere else
                              </li>
                              <li>
                                Access the earliest word on pensions and
                                institutional investors' engagement in addition
                                to upcoming plans to launch funds
                              </li>
                            </ul>
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item key={2} xs={12} sm={12} md={6}>
                      <Card className={classes.hfaCard}>
                        <CardContent className={classes.hfaCardContent}>
                          <img
                            className={clsx(
                              classes.cmImg,
                              classes.breakingNews
                            )}
                            src={risks}
                            alt={process.env.REACT_APP_SITE_NAME}
                          />
                          <Typography
                            component="h3"
                            variant="h3"
                            align="center"
                            gutterBottom
                            className={classes.hfaCardContentTitle}
                          >
                            Identify Timely Risks and Opportunities
                          </Typography>
                          <Typography paragraph gutterBottom>
                            <ul>
                              <li>
                                Gain visibility on the reasoning behind hedge
                                fund feats and failures, including technological
                                and operational successes
                              </li>
                              <li>
                                Understand the challenges facing fund managers
                                with a run-down of pending regulations and other
                                industry disruptors
                              </li>
                            </ul>
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item key={3} xs={12} sm={12} md={6}>
                      <Card className={classes.hfaCard}>
                        <CardContent className={classes.hfaCardContent}>
                          <img
                            className={clsx(
                              classes.cmImg,
                              classes.breakingNews
                            )}
                            src={competition}
                            alt={process.env.REACT_APP_SITE_NAME}
                          />
                          <Typography
                            component="h3"
                            variant="h3"
                            align="center"
                            gutterBottom
                            className={classes.hfaCardContentTitle}
                          >
                            Inform Direction of Investment Strategies
                          </Typography>
                          <Typography paragraph gutterBottom>
                            <ul>
                              <li>
                                Detect business development opportunities with
                                access to data on major fund launches,
                                performance and fund raising
                              </li>
                              <li>
                                Augment competitive tactics with access to fund,
                                fund management, prime broker and auditor
                                rankings
                              </li>
                            </ul>
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item key={4} xs={12} sm={12} md={6}>
                      <Card className={classes.hfaCard}>
                        <CardContent className={classes.hfaCardContent}>
                          <img
                            className={clsx(
                              classes.cmImg,
                              classes.breakingNews
                            )}
                            src={idea}
                            alt={process.env.REACT_APP_SITE_NAME}
                          />
                          <Typography
                            component="h3"
                            variant="h3"
                            align="center"
                            gutterBottom
                            className={classes.hfaCardContentTitle}
                          >
                            Garner a Recruitment Edge
                          </Typography>
                          <Typography paragraph gutterBottom>
                            <ul>
                              <li>
                                Learn of career openings, corporate setbacks and
                                personnel cuts in the much-coveted Grapevine
                                column
                              </li>
                            </ul>
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <Grid container spacing={4}>
                    <Grid item key={1} xs={12} sm={12} md={8}>
                      <Card className={classes.hfaCard}>
                        <CardContent className={classes.hfaCardContent}>
                          <Typography
                            component="h3"
                            variant="h3"
                            align="center"
                            gutterBottom
                            className={classes.hfaCardContentTitle}
                          >
                            What does Hedge Fund Alert cover?
                          </Typography>
                          <Typography paragraph gutterBottom>
                            <ul>
                              <li>
                                Behind-the-scenes courting of pensions and other
                                institutional investors
                              </li>
                              <li>
                                Steps taken by managers to comply with the new
                                wave of fund regulations
                              </li>
                              <li>
                                Wall Street traders' confidential plans to
                                launch funds
                              </li>
                              <li>Secret circumstances behind fund blow-ups</li>
                              <li>
                                Brokers and other service providers jockeying
                                for market share
                              </li>
                              <li>
                                Career moves by key industry professionals
                              </li>
                              <li>
                                Technology and operational successes, failures
                                and challenges of fund managers
                              </li>
                            </ul>
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item key={1} xs={12} sm={12} md={4}>
                      <Card className={classes.hfaCard}>
                        <CardContent className={classes.hfaCardContent}>
                          <Typography
                            component="h3"
                            variant="h3"
                            align="center"
                            gutterBottom
                            className={classes.hfaCardContentTitle}
                          >
                            To contribute to a story, please contact:
                          </Typography>
                          <Typography paragraph gutterBottom>
                            Mark Mueller
                            <br />
                            732-939-9801
                            <br />
                            m.mueller@hedgefundalert.com
                          </Typography>
                          <Typography paragraph gutterBottom>
                            Howard Kapiloff
                            <br />
                            917-576-0709
                            <br />
                            h.kapiloff@hedgefundalert.com
                          </Typography>
                          <Typography paragraph gutterBottom>
                            Samantha Marcus
                            <br />
                            609-819-2384
                            <br />
                            s.marcus@hedgefundalert.com
                          </Typography>
                          <Typography paragraph gutterBottom>
                            Mike Frassinelli
                            <br />
                            973-856-3263
                            <br />
                            m.frassinelli@hedgefundalert.com
                          </Typography>
                          <Typography paragraph gutterBottom>
                            James Prado Roberts
                            <br />
                            732-322-8780
                            <br />
                            j.pradoroberts@hedgefundalert.com
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item key={1} xs={12} sm={12} md={12}>
                      <Card className={classes.hfaCard}>
                        <CardContent className={classes.hfaCardContent}>
                          <Typography
                            component="h3"
                            variant="h3"
                            align="center"
                            gutterBottom
                            className={classes.hfaCardContentTitle}
                          >
                            Who produces Hedge Fund Alert?
                          </Typography>
                          <Typography paragraph gutterBottom>
                            Its reporters have impressive records of covering
                            alternative investments and other financial fields
                            for the last 20 years. The newsletter was launched
                            in 2000, when institutional investors became focused
                            on hedge funds and triggered the industry's
                            explosive growth. Since then, Hedge Fund Alert has
                            served as the eyes and ears for the industry's
                            leading players.
                          </Typography>
                          <Grid
                            container
                            spacing={4}
                            className={classes.keyPersonWrap}
                          >
                            {keyPersons.map((person, i) => (
                              <Grid item key={i} xs={12} sm={6} md={3}>
                                <Card
                                  className={classes.hfaCsCard}
                                  onClick={() => {
                                    handleOpen(i);
                                  }}
                                >
                                  <CardContent
                                    className={classes.cardTeamContent}
                                  >
                                    <Box
                                      className={classes.teamImg}
                                      style={{
                                        backgroundImage: `url(${person.avatar})`,
                                      }}
                                    ></Box>
                                    <Box className={classes.teamDetail}>
                                      <Typography
                                        component="h3"
                                        variant="h3"
                                        align="left"
                                        gutterBottom
                                        className={classes.teamName}
                                      >
                                        {person.name}
                                      </Typography>
                                      <Typography
                                        paragraph
                                        gutterBottom
                                        className={classes.teamPosition}
                                      >
                                        {person.position}
                                      </Typography>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Grid>
                            ))}
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <Grid container spacing={4}>
                    <Grid item key={1} xs={12} sm={12} md={12}>
                      <Card className={classes.hfaCard}>
                        <CardContent className={classes.hfaCardContent}>
                          <Typography
                            component="h3"
                            variant="h3"
                            align="center"
                            gutterBottom
                            className={classes.hfaCardContentTitle}
                          >
                            Manager Database:
                          </Typography>
                          <Typography paragraph gutterBottom>
                            Hedge Fund Alert's Manager Database offers detailed
                            views of more than 3,000 fund-management firms and
                            the hedge funds they run. The information is called
                            from Form ADV disclosures that fund managers file
                            with the SEC and from Hedge Fund Alert's own
                            research (coming soon).
                          </Typography>
                          <Typography paragraph gutterBottom>
                            For questions about Manager Database, please email
                            us on{" "}
                            <a
                              className={classes.subscribeTextLink}
                              href="mailto:support@hedgefundalert.com"
                            >
                              support@hedgefundalert.com
                            </a>
                            .
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    {/*<Grid item key={1} xs={12} sm={12} md={12}>*/}
                    {/*    <Link to="/downlaod-pdf" className={classes.hfaLink}>*/}
                    {/*        <PictureAsPdfIcon></PictureAsPdfIcon>*/}
                    {/*        <span className={classes.hfaLinkSpan}>Hedge Fund Manager Database Methodology</span>*/}
                    {/*    </Link>*/}
                    {/*</Grid>*/}
                  </Grid>
                </TabPanel>
              </Box>
            </Hidden>
            <Hidden smUp>
              <Box>
                <div className={classes.collapseRoot}>
                  <Accordion className={classes.accordion}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className={classes.headingAccordion}>
                        Overview
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={4}>
                        <Grid item key={1} xs={12} sm={12} md={6}>
                          <Card className={classes.hfaCard}>
                            <CardContent className={classes.hfaCardContent}>
                              <img
                                className={clsx(
                                  classes.cmImg,
                                  classes.breakingNews
                                )}
                                src={breakingNews}
                                alt={process.env.REACT_APP_SITE_NAME}
                              />
                              <Typography
                                component="h3"
                                variant="h3"
                                align="center"
                                gutterBottom
                                className={classes.hfaCardContentTitle}
                              >
                                Receive Breaking News &amp; Exclusive Stories
                              </Typography>
                              <Typography paragraph gutterBottom>
                                <ul>
                                  <li>
                                    Obtain spotlights on key industry
                                    developments that haven't been reported
                                    anywhere else
                                  </li>
                                  <li>
                                    Access the earliest word on pensions and
                                    institutional investors' engagement in
                                    addition to upcoming plans to launch funds
                                  </li>
                                </ul>
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item key={2} xs={12} sm={12} md={6}>
                          <Card className={classes.hfaCard}>
                            <CardContent className={classes.hfaCardContent}>
                              <img
                                className={clsx(
                                  classes.cmImg,
                                  classes.breakingNews
                                )}
                                src={risks}
                                alt={process.env.REACT_APP_SITE_NAME}
                              />
                              <Typography
                                component="h3"
                                variant="h3"
                                align="center"
                                gutterBottom
                                className={classes.hfaCardContentTitle}
                              >
                                Identify Timely Risks and Opportunities
                              </Typography>
                              <Typography paragraph gutterBottom>
                                <ul>
                                  <li>
                                    Gain visibility on the reasoning behind
                                    hedge fund feats and failures, including
                                    technological and operational successes
                                  </li>
                                  <li>
                                    Understand the challenges facing fund
                                    managers with a run-down of pending
                                    regulations and other industry disruptors
                                  </li>
                                </ul>
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item key={3} xs={12} sm={12} md={6}>
                          <Card className={classes.hfaCard}>
                            <CardContent className={classes.hfaCardContent}>
                              <img
                                className={clsx(
                                  classes.cmImg,
                                  classes.breakingNews
                                )}
                                src={competition}
                                alt={process.env.REACT_APP_SITE_NAME}
                              />
                              <Typography
                                component="h3"
                                variant="h3"
                                align="center"
                                gutterBottom
                                className={classes.hfaCardContentTitle}
                              >
                                Inform Direction of Investment Strategies
                              </Typography>
                              <Typography paragraph gutterBottom>
                                <ul>
                                  <li>
                                    Detect money-making openings with access to
                                    data on major fund launches, performance and
                                    fund raising
                                  </li>
                                  <li>
                                    Augment competitive tactics with access to
                                    fund, fund management, prime broker and
                                    auditor rankings
                                  </li>
                                </ul>
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item key={4} xs={12} sm={12} md={6}>
                          <Card className={classes.hfaCard}>
                            <CardContent className={classes.hfaCardContent}>
                              <img
                                className={clsx(
                                  classes.cmImg,
                                  classes.breakingNews
                                )}
                                src={idea}
                                alt={process.env.REACT_APP_SITE_NAME}
                              />
                              <Typography
                                component="h3"
                                variant="h3"
                                align="center"
                                gutterBottom
                                className={classes.hfaCardContentTitle}
                              >
                                Garner a Recruitment Edge
                              </Typography>
                              <Typography paragraph gutterBottom>
                                <ul>
                                  <li>
                                    Learn of structured-finance career openings,
                                    corporate setbacks and personnel cuts in the
                                    much-coveted Grapevine column
                                  </li>
                                </ul>
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className={classes.accordion}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={classes.headingAccordion}>
                        Publication Coverage
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={4}>
                        <Grid item key={1} xs={12} sm={12} md={8}>
                          <Card className={classes.hfaCard}>
                            <CardContent className={classes.hfaCardContent}>
                              <Typography
                                component="h3"
                                variant="h3"
                                align="center"
                                gutterBottom
                                className={classes.hfaCardContentTitle}
                              >
                                What does Hedge Fund Alert cover?
                              </Typography>
                              <Typography paragraph gutterBottom>
                                <ul>
                                  <li>
                                    Behind-the-scenes courting of pensions and
                                    other institutional investors
                                  </li>
                                  <li>
                                    Steps taken by managers to comply with the
                                    new wave of fund regulations
                                  </li>
                                  <li>
                                    Wall Street traders' confidential plans to
                                    launch funds
                                  </li>
                                  <li>
                                    Secret circumstances behind fund blow-ups
                                  </li>
                                  <li>
                                    Brokers and other service providers
                                    jockeying for market share
                                  </li>
                                  <li>
                                    Career moves by key industry professionals
                                  </li>
                                  <li>
                                    Technology and operational successes,
                                    failures and challenges of fund managers
                                  </li>
                                </ul>
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item key={1} xs={12} sm={12} md={4}>
                          <Card className={classes.hfaCard}>
                            <CardContent className={classes.hfaCardContent}>
                              <Typography
                                component="h3"
                                variant="h3"
                                align="center"
                                gutterBottom
                                className={classes.hfaCardContentTitle}
                              >
                                To contribute to a story, please contact:
                              </Typography>
                              <Typography paragraph gutterBottom>
                                Howard Kapiloff
                                <br />
                                201-234-3976
                                <br />
                                hkapiloff@greenstreetnews.com
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item key={1} xs={12} sm={12} md={12}>
                          <Card className={classes.hfaCard}>
                            <CardContent className={classes.hfaCardContent}>
                              <Typography
                                component="h3"
                                variant="h3"
                                align="center"
                                gutterBottom
                                className={classes.hfaCardContentTitle}
                              >
                                Who produces Hedge Fund Alert?
                              </Typography>
                              <Typography paragraph gutterBottom>
                                Its editors have impressive records of covering
                                alternative investments and other financial
                                fields for the last 20 years. The newsletter was
                                launched in 2000, when institutional investors
                                became focused on hedge funds and triggered the
                                industry's explosive growth. Since then, Hedge
                                Fund Alert has served as the eyes and ears for
                                the industry's leading players.
                              </Typography>
                              <Grid container spacing={4}>
                                {keyPersons.map((person, i) => (
                                  <Grid item key={i} xs={12} sm={6} md={3}>
                                    <Card
                                      className={classes.hfaCsCard}
                                      onClick={() => {
                                        handleOpen(i);
                                      }}
                                    >
                                      <CardContent
                                        className={classes.cardTeamContent}
                                      >
                                        <Box
                                          className={classes.teamImg}
                                          style={{
                                            backgroundImage: `url(${person.avatar})`,
                                          }}
                                        ></Box>
                                        <Box className={classes.teamDetail}>
                                          <Typography
                                            component="h3"
                                            variant="h3"
                                            align="left"
                                            gutterBottom
                                            className={classes.teamName}
                                          >
                                            {person.name}
                                          </Typography>
                                          <Typography
                                            paragraph
                                            gutterBottom
                                            className={classes.teamPosition}
                                          >
                                            {person.position}
                                          </Typography>
                                        </Box>
                                      </CardContent>
                                    </Card>
                                  </Grid>
                                ))}
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className={classes.accordion}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={classes.headingAccordion}>
                        About The Databases
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={4}>
                        <Grid item key={1} xs={12} sm={12} md={12}>
                          <Card className={classes.hfaCard}>
                            <CardContent className={classes.hfaCardContent}>
                              <Typography
                                component="h3"
                                variant="h3"
                                align="center"
                                gutterBottom
                                className={classes.hfaCardContentTitle}
                              >
                                Manager Database:
                              </Typography>
                              <Typography paragraph gutterBottom>
                                Hedge Fund Alert's Manager Database offers
                                detailed views of more than 3,000
                                fund-management firms and the hedge funds they
                                run. The information is called from Form ADV
                                disclosures that fund managers file with the SEC
                                and from Hedge Fund Alert's own research (coming
                                soon).
                              </Typography>
                              <Typography paragraph gutterBottom>
                                For questions about Manager Database, please
                                email us on{" "}
                                <a
                                  className={classes.subscribeTextLink}
                                  href="mailto:support@hedgefundalert.com"
                                >
                                  support@hedgefundalert.com
                                </a>
                                .
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        {/*<Grid item key={1} xs={12} sm={12} md={12}>*/}
                        {/*    <Link to="/downlaod-pdf" className={classes.hfaLink}>*/}
                        {/*        <PictureAsPdfIcon></PictureAsPdfIcon>*/}
                        {/*        <span className={classes.hfaLinkSpan}>Hedge Fund Manager Database Methodology</span>*/}
                        {/*    </Link>*/}
                        {/*</Grid>*/}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </Box>
            </Hidden>
          </Container>
        </Box>

        <ContactUsBanner />

        <SocialBanner />
      </div>
      <Modal
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-member"
        aria-describedby="modal-member"
      >
        <>
          <Button
            variant="contained"
            color="primary"
            className={classes.closeModalBtn}
            onClick={handleClose}
          >
            <CloseIcon></CloseIcon>
          </Button>
          {bodyModal}
        </>
      </Modal>
      {/*<div className={classes.heroContent}>*/}
      {/*    <Container maxWidth="sm">*/}
      {/*        <Typography*/}
      {/*            component="h1"*/}
      {/*            variant="h2"*/}
      {/*            align="center"*/}
      {/*            color="textPrimary"*/}
      {/*            gutterBottom*/}
      {/*        >*/}
      {/*            Hedge Fund Alert!*/}
      {/*        </Typography>*/}
      {/*        <Typography*/}
      {/*            variant="h5"*/}
      {/*            align="center"*/}
      {/*            color="textSecondary"*/}
      {/*            paragraph*/}
      {/*        >*/}
      {/*            Weekly update shedding light on the key operations of the secretive*/}
      {/*            fund-management industry*/}
      {/*        </Typography>*/}
      {/*        <div className={classes.heroButtons}>*/}
      {/*            <Grid container spacing={2} justify="center">*/}
      {/*                <Grid item>*/}
      {/*                    <Button*/}
      {/*                        variant="contained"*/}
      {/*                        color="primary"*/}
      {/*                        component={RouteLink}*/}
      {/*                        to="/user/signup"*/}
      {/*                    >*/}
      {/*                        Subscribe*/}
      {/*                    </Button>*/}
      {/*                </Grid>*/}
      {/*                <Grid item>*/}
      {/*                    <Button*/}
      {/*                        variant="outlined"*/}
      {/*                        color="primary"*/}
      {/*                        component={RouteLink}*/}
      {/*                        to="/user/login"*/}
      {/*                        //onClick={onLogIn}*/}
      {/*                    >*/}
      {/*                        {isLoggedin ? "Login" : "Login"}*/}
      {/*                    </Button>*/}
      {/*                </Grid>*/}
      {/*            </Grid>*/}
      {/*        </div>*/}
      {/*    </Container>*/}
      {/*</div>*/}

      {/*<Container className={classes.cardGrid} maxWidth="md">*/}
      {/*    /!* End hero unit *!/*/}
      {/*    <Grid container spacing={4}>*/}
      {/*        {cards.map((card, i) => (*/}
      {/*            <Grid item key={card} xs={12} sm={6} md={4}>*/}
      {/*                <Card className={classes.card}>*/}
      {/*                    <CardContent className={classes.cardContent}>*/}
      {/*                        <Typography*/}
      {/*                            className={classes.cardContentTitle}*/}
      {/*                            variant="h6"*/}
      {/*                            component="h2"*/}
      {/*                            gutterBottom*/}
      {/*                        >*/}
      {/*                            {titles[i]}*/}
      {/*                        </Typography>*/}
      {/*                        <Typography>*/}
      {/*                            This is a media card. You can use this section to describe*/}
      {/*                            the content.*/}
      {/*                        </Typography>*/}
      {/*                    </CardContent>*/}
      {/*                    <CardActions>*/}
      {/*                        <Button size="small" color="primary">*/}
      {/*                            Read More*/}
      {/*                        </Button>*/}
      {/*                    </CardActions>*/}
      {/*                </Card>*/}
      {/*            </Grid>*/}
      {/*        ))}*/}
      {/*    </Grid>*/}
      {/*</Container>*/}
    </>
  );
}
